import { definePreset } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'

const CustomTheme = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#fff8e3',
      100: '#ffe9aa',
      200: '#ffda71',
      300: '#ffcc39',
      400: '#ffbd00',
      500: '#fbba00',
      600: '#c69300',
      700: '#8e6900',
      800: '#553f00',
      900: '#1c1500',
    },
    grey: {
      50: '#fafafa',
      100: '#f2f2f2',
      200: '#dddddd',
      300: '#bbbbbb',
      400: '#999999',
      500: '#6b7280',
      600: '#8e8e8e',
      700: '#777777',
      800: '#606060',
      900: '#4a4a4a',
    },
    info: {
      50: '#ebfaff',
      100: '#d1f0fa',
      200: '#9ae6ff',
      300: '#48d1ff',
      400: '#20c7ff',
      500: '#00b9f6',
      600: '#009ace',
      700: '#007ca5',
      800: '#005d7d',
      900: '#003f54',
    },
    success: {
      50: '#eafddc',
      100: '#cbf1d1',
      200: '#97e2a3',
      300: '#5cc16b',
      400: '#2b9d3c',
      500: '#248232',
      600: '#1d6828',
      700: '#164e1e',
      800: '#0e3414',
      900: '#071a0a',
    },
    warning: {
      50: '#fffbf0',
      100: '#f8e7bf',
      200: '#f7e2b3',
      300: '#ffd77b',
      400: '#edc25d',
      500: '#e8b233',
      600: '#c28b0a',
      700: '#b27d00',
      800: '#704f00',
      900: '#3f2f00',
    },
    error: {
      50: '#fff1f2',
      100: '#ffe4e6',
      200: '#fecdd3',
      300: '#fda4af',
      400: '#fb7185',
      500: '#ec4899',
      600: '#db2777',
      700: '#be123c',
      800: '#9f1239',
      900: '#881337',
    },
    text: {
      active: '#3D3F4C',
    },
    borderRadius: {
      xs: '3px',
      sm: '4px',
      md: '6px',
      lg: '8px',
      xl: '12px',
    },
    fontFamily: {
      primary: 'Nunito Sans, sans-serif',
    },
    boxShadow: {
      sm: '0 2px 4px 0 rgba(27, 28, 29, 0.04)',
      md: '0 2px 10px 0px rgba(88, 92, 95, 0.1)',
      lg: '0 16px 40px 0px rgba(88, 92, 95, 0.16)',
    },
    fontSize: {},
    lineHeight: {},
  },
  components: {
    button: {
      root: {
        paddingX: '16px',
        paddingY: '12px',
        borderRadius: '12px',
      },
      colorScheme: {
        light: {
          root: {
            primary: {
              color: '#000',
            },
            secondary: {
              borderColor: '#000',
              hoverBorderColor: '#000',
              background: '#000',
            },
          },
        },
      },
    },
    select: {
      root: {
        paddingX: '10px',
        paddingY: '12px',
        borderRadius: '12px',
      },
    },

    inputtext: {
      colorScheme: {
        light: {
          root: {
            paddingX: '10px',
            paddingY: '12px',
          },
        },
      },
    },
  },
})

export { CustomTheme }
